import React, { Component } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Layout } from '../Layout';
import '../../Asset/vendors/base/vendors.bundle.css';
import '../../Asset/demo/default/base/style.bundle.css';
import '../../Asset/custom.css';
import { Card, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import Spinner from '../Spinner';
import download from 'downloadjs';
import global from '../global';
import { config } from '../../Constants';

export class ESignSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: 100,
            pdfLocation: '',
            url: '',
            loading: false
        };

        this.state.url = config.url.Web_URL + `/${localStorage.getItem('remitterCode')}`;
    }

    componentDidMount() {
        console.log(this.props)
        
    }

    handleDownload = (e) => {
        this.setState({ loading: true });
        axios.get(global.Form15GH.DownloadDigiSignedPdfAPI,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/pdf' },
                responseType: 'blob'
            })
            .then(response => {
                const content = response.headers['content-type'];
                const fileName = 'SignedDoc.pdf'
                download(response.data, fileName, content)
                this.setState({ loading: false });

                var url = config.url.Web_URL;
                sessionStorage.clear(); //for sessionStorage
                window.location.href = url + `/${localStorage.getItem('remitterCode')}`;
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false });
            });
    }

    render() {
        if (this.state.loading) return <Spinner />;
        
        let content = Layout.RenderNavMenu();

        return (

            <div>
                {content}
                <div className="m-grid__item m-grid__item--fluid m-wrapper">
                    <div className="Nexdigm">
                        <ol className="breadcrumb btn-Nexdigm">
                            <li><a href={this.state.url + "/Dashboard"} className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                            <li><a href={this.state.url + "/Form15GH"} className="text-white">Form 15 G/H</a></li>
                            <li><a className="text-white">Success</a></li>
                        </ol>
                    </div>
                    <div className="content-page">
                        <div className="card">
                            <div className="card-body">
                                <Row>
                                    <Col md={12}>
                                        <h4 className="text-center text-success">Document Signed Successfully!</h4>
                                        <div className="vertical-center">
                                            <button className="btn btn-success m-t-25 m-l-10 h-40 text-center" onClick={this.handleDownload}>Download Signed PDF & Log Out</button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
  
